import styled from "styled-components";
import { Box, Text } from "@vinomofo/components";
import { useIntersectionObserver } from "../../hooks/use-intersection-observer";
import { AnimatedDigits } from "./AnimatedDigits";
import { useState } from "react";
import { useNumberAnimation } from "../../hooks/use-number-animation";



const NumberWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  overflow: hidden;
  min-height: 200px;

  @media ${({ theme }) => theme.mq.max.mobile} {
    min-height: 100px;
  }
`;

const CounterLabel = styled(Text)`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 29px;
  color: #f3b659;
  text-transform: uppercase;
  font-weight: 500;
  text-align: center;
  letter-spacing: 1px;
  margin-top: 12px;

  @media ${({ theme }) => theme.mq.max.mobile} {
    font-size: 20px;
  }
`;

interface NumberCounterProps {
  targetNumber: number;
  duration?: number;
  label?: string;
}

const NumberCounter = ({
  targetNumber,
  duration = 2000,
  label,
}: NumberCounterProps) => {
  const [hasRun, setHasRun] = useState(false);

  const { displayNumber, animate, hasRunRef } = useNumberAnimation({
    targetNumber,
    duration,
    hasRun,
  });

  const elementRef = useIntersectionObserver({
    onIntersect: () => {
      setHasRun(true);
      hasRunRef.current = true;
    },
    hasRun: hasRunRef.current,
  });
  return (
    <NumberWrapper ref={elementRef}>
      <AnimatedDigits displayNumber={displayNumber} animate={animate} />
      {label && <CounterLabel>{label}</CounterLabel>}
    </NumberWrapper>
  );
};

export { NumberCounter };
